import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
import { ElMessage } from "element-plus";

const service = axios.create({
  baseURL: process.env.NODE_ENV === "", //开发用
  timeout: 6000000,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    withCredentials: true,
    "zh-token": Cookies.get("Admin-Token"),
  },
  withCredentials: true,
});
service.defaults.withCredentials = true;

service.interceptors.request.use(
  async (config) => {
    if (getToken()) {
      config.headers["zh-token"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    if (config.type === "formData" && config.data.constructor != FormData) {
      var data = new FormData();
      for (var key in config.data) {
        var val = config.data[key];
        if (val === null || val === undefined) {
          data.append(key, "");
        } else if (val.constructor == Array) {
          for (var i = 0; i < val.length; i++) {
            data.append(
              key,
              typeof val[i] == "object" ? JSON.stringify(val[i]) : val[i]
            );
          }
        } else {
          data.append(key, typeof val == "object" ? JSON.stringify(val) : val);
        }
      }
      config.data = data;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (res) => {
    if (res.status == 200 && res.config.responseType === "blob") {
      if(res.data.type.includes('json')) {
          const reader = new FileReader()
          reader.readAsText(res.data, 'utf-8')
          reader.onload = () => {
            const data = JSON.parse(reader.result);
             ElMessage({
              message: data.message,
              type: "error",
            });
          }
          return Promise.reject("error");
      }
      // 返回的是文件流格式
      const disposition = res.headers["content-disposition"];
      const fileName = disposition.split("filename=")[1].replace(/\\"/g, "");
      const decodeFileName = decodeURI(fileName);
      return {fileName: decodeFileName, blob: res.data};
    }
    // 未设置状态码则默认成功状态
    const code = res.data.code || 2000;
    // 获取错误信息
    const msg = res.data.message || errorCode["default"];
    if (code.includes("B.Auth")) {
      ElMessage({
        message: msg,
        type: "error",
      });
        window.$goPage("/login");
      return Promise.reject(msg);
    } else if (code !== "2000") {
      ElMessage({
        message: msg,
        type: "error",
      });
      return Promise.reject("error");
    } else {
      return res.data;
    }
  },
  (error) => {
    ElMessage({
      message: error.message || "接口报错",
      type: "warning",
    });
    return Promise.reject(error);
  }
);

export default service;
